<template>
  <div>
  <v-dialog v-model="show" persistent max-width="500px">
    <v-card>
      <v-toolbar color="#CFDDE6" dark height="48px">
         <span v-if="parentId === ''">
          {{
            oldDirectoryData.id
              ? $t("documents.renameDirectory")
              : $t("documents.newRoot")
          }}</span
        >
        <span v-else>
          {{
            oldDirectoryData.id
              ? $t("documents.renameFolder")
              : $t("documents.newFolder")
          }}</span
        >
        <v-spacer></v-spacer>
        <CloseIcon @click="close" />
      </v-toolbar>

      <v-card-text>
        <v-form ref="refAddFolderForm" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                class="textField"
                color="neutralGray"
                hide-details="auto"
                dense
                filled
                v-model.trim="folderName"
                :label="
                  parentId === ''
                    ? $t('documents.lblRootDir')
                    : $t('documents.lblFolderPlaceholder')
                "
                :rules="parentId === '' ? dirRequiredRules : requiredRules"
                required
                @keydown.enter.prevent="addFolder"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom v-if="parentId === ''">
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="primaryDark"
              @click="addFolder"
              v-if="parentId === ''"
            >
              {{ oldDirectoryData.id ? $t("btnSave") : $t("btnAdd") }}
            </a-btn>
          </template>
          <span>{{ oldDirectoryData.id ? $t("btnSave") : $t("btnAdd") }}</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="primaryDark"
              @click="addFolder"
            >
              {{ oldDirectoryData.id ? $t("btnSave") : $t("btnAdd") }}
            </a-btn>
          </template>
          <span>{{ oldDirectoryData.id ? $t("btnSave") : $t("btnAdd") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="secondary ml-2"
              @click="close"
              >{{ $t("btnCancel") }}</a-btn
            >
          </template>
          <span>{{ $t("btnCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <MessageSheet
    :showMessage="displayMessage"
    :message="message"
    :messageType="messageType"
    @close="displayMessage = false"
  ></MessageSheet>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { createUUID } from "../../utils/util";
import MessageSheet from "../MessageSheet.vue";
export default {
  name: "CreateDirectory",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    parentId: {
      type: String,
      default: "",
    },
    directory_names: {
      type: Array,
      default: [],
    },
    directoryData: {
      type: Object,
      default: {},
    },
    },
  components: {
    MessageSheet
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    loaderText() {
      return this.$t("LoaderText");
    },
  },
  watch: {
    directoryData(newValue) {
      if (newValue) {
        this.oldDirectoryData = this.directoryData;
        this.folderName = this.oldDirectoryData.name;
        this.currentDirectory = this.oldDirectoryData.name;
      }
    },
  },
  data() {
    return {
      currentDirectory: "",
      oldDirectoryData: {},
      folderName: "",
      displayMessage: false,
      message: "",
      messageType: "",
      valid: true,
      requiredRules: [
        (v) => !!(v ? v.trim() : "") || this.$t("documents.ruleFolderNameReq"),
        (v) =>
          (v ? !this.checkUnique(v.trim()) : !this.checkUnique("")) ||
          this.$t("documents.ruleFolderNameUnique"),
      ],
      dirRequiredRules: [
        (v) =>
          !!(v ? v.trim() : "") || this.$t("documents.ruleDirectoryNameReq"),
        (v) =>
          (v ? !this.checkUnique(v.trim()) : !this.checkUnique("")) ||
          this.$t("documents.ruleDirectoryNameUnique"),
      ],
    };
 },
  methods: {
    ...mapActions({
      createDirectory: "directory/createDirectory",
      updateDirectory: "directory/updateDirectory",
    }),
    checkUnique(title) {
      let flag;
      if (title.toLowerCase() === this.currentDirectory.toLowerCase()) {
        flag = !this.directory_names.some(
          (x) => this.currentDirectory.toLowerCase() === title.toLowerCase()
        );
      } else {
        flag = this.directory_names.some(
          (x) => x.toLowerCase() === title.toLowerCase()
        );
      }
      return flag;
    },
    addFolder,
    close,
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
  },
};

async function addFolder() {
  if (this.$refs.refAddFolderForm.validate()) {
    try {
      const data = {
          id: this.oldDirectoryData.id ? this.oldDirectoryData.id : createUUID(),
          tenantid: sessionStorage.getItem("tenantId"),
          parentId: this.oldDirectoryData.id ? this.oldDirectoryData.parentId : this.parentId,
          name: this.folderName,
        };
      if (this.oldDirectoryData.id) {
        await this.updateDirectory(data);
        this.showMessageSheet(
          this.$t("documents.DirectoryUpdateSuccessMessage"),
          "success"
        );
      } else {
        await this.createDirectory(data);
        this.showMessageSheet(
          this.$t("documents.DirectoryCreateSuccessMessage"),
          "success"
        );
      }
    } catch (error) {
      this.close();
    }
    this.close();
  }
}

function close() {
  this.$refs.refAddFolderForm.resetValidation();
  this.$refs.refAddFolderForm.reset();
  this.oldDirectoryData = {};
  this.$emit("input", false);
}
</script>

<style scoped>
.v-sheet.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  box-shadow: none !important;
}

.v-toolbar /deep/ .v-toolbar__content {
  color: var(--v-darkCharcoal-base);
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
}

.textField {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  max-height: 68px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
  border-radius: 0 !important;
}

.textField > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}

.textField /deep/ .v-input__control {
  border-radius: 0 !important;
}
</style>